import AppDataService from "./AppDataService";

export default class DataLoaderDataService {
    
    static async getConfig(){
        return await AppDataService.get('config/Get');
    }
}